import { BrandCode, EnvConfig } from 'types';

const config: EnvConfig = {
	env: 'prd',
	endpoints: {
		affirmApi: 'https://cdn1.affirm.com/js/v2/affirm.js',
		dictionaryApi: 'https://www.royalcaribbean.com/bin/services/royal/dictionary',
		utilsApi: 'https://www.royalcaribbean.com/utils/service',
	},
	publicKeys: {
		launchDarklyClientSideId: '61f97f4094fa1b16de90c390',
		guestAccountClientId: 'g9S023t74473ZUk909FN68F0b4N67PSOh92o04vL0BR6537pI2y2h94M6BbU7D6J',
		utilsGenerateId: '8e25c069-4097-48a3-a22f-c691d2fa27eb',
	},
	brands: {
		[BrandCode.Celebrity]: {
			baseUrl: 'https://www.celebritycruises.com',
			mapsBaseUrl: 'https://www.celebritycruises.com',
			publicKeys: {
				affirmPublicId: 'EGQHMJFO75CHHCHR',
				appDynamicsAppKey: 'AD-AAB-AAT-KRJ',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-23.10.1.4359.js',
			},
			resources: {
				favicon: '/favicon.ico',
			},
		},
		[BrandCode.RoyalCaribbean]: {
			baseUrl: 'https://www.royalcaribbean.com',
			mapsBaseUrl: 'https://www.royalcaribbean.com/content/dam',
			publicKeys: {
				affirmPublicId: 'TS5PQRZFRZDZ5NQ1',
				appDynamicsAppKey: 'AD-AAB-AAU-AJK',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-23.10.1.4359.js',
			},
			resources: {
				favicon: '/content/dam/royal/resources/icons/logo/favicon.ico',
			},
		},
	},
};

export default config;
